import StoreUser from "../entities/StoreUser";
export var users = getUsers();
function getUsers() {
    var loadData = localStorage.getItem("users");
    var users = [];
    var loadDataJson;
    if (loadData) {
        loadDataJson = JSON.parse(loadData);
        loadDataJson.forEach(function (element) {
            var user = new StoreUser();
            user.create(element);
            users.push(user);
        });
        return users;
    }
    return [];
}
export function postUsers() {
    localStorage.setItem("users", JSON.stringify(users));
}
export function getUserByEMail(userMail) {
    if (users) {
        return users.filter(function (userEl) { return userEl.mailAdress == userMail; })[0];
    }
    return null;
}
